export const schedule_formdata = (state) => {
  return state.schedule_formdata;
};
